import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { api, type SearchParams } from '../api/client';
import type { AppConfig } from '../config';

export function useRestaurants(config: AppConfig, params: SearchParams) {
  return useQuery({
    queryKey: ['restaurants', params],
    queryFn: () => api.search(config, params),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}
